import { DriverDetailsFormModel_OB_FP } from './formModel';

export const getInitialValues = (): DriverDetailsFormModel_OB_FP => {
  return {
    firstName: '',
    lastName: '',
  };
};
